import { api } from './http'
import { and, or, searchParam } from './filters'

// Contratos VERIFICADOS EN VIVO contra el backend MT (2026-06-25).

// --- Typeahead de productos ---
// VIVO: GET /productos?view=BaseList&search=<JSON>  -> HTTP 200, items ricos
// (id, codigo, nombre, codigoBarrasPrincipal, tiposImpuesto, unidadesMedida, unidadMedidaBase...).
//
// GOTCHA confirmado en el MT: el filtro OR que incluye el path con join
// `codigoBarrasPrincipal.codigoBarras` (como hace el Angular original, form.js:7676)
// devuelve HTTP 500 en este backend. El OR con solo paths DIRECTOS (nombre, codigo)
// devuelve 200. Por eso acá el typeahead omite el código de barras.
// // PENDIENTE: si se necesita buscar por código de barras, ver por qué el join 500ea
// // en MT (¿columna/relación faltante en el tenant?) antes de re-agregar ese path.
//
// Disparo a partir de 3 caracteres (igual que el front Angular). Sin `view=BaseList`
// los items vienen finos (solo {id, codigo, unidadesMedida}).
export function buscarProductos(searchValue, { view = 'BaseList' } = {}) {
  if (!searchValue || searchValue.length < 3) return Promise.resolve([])
  const v = searchValue
  const filtro = or([
    and([{ path: 'nombre', like: v }]),
    and([{ path: 'codigo', like: v }]),
  ])
  return api.get('/productos', { params: searchParam(filtro, { view }) }).then((r) => r.data)
}

// --- Detalle por id ---
// El factory Angular usa GET /productos/{id}?view=base.
export function getProducto(id, view = 'BaseList') {
  return api.get(`/productos/${id}`, { params: { view } }).then((r) => r.data)
}

// --- Typeahead de servicios ---
// VIVO: GET /servicios?search=<and(descripcion like ...)> -> HTTP 200 (104 items).
// El factory Angular filtra por { path:'descripcion', like:search } (single -> and).
export function buscarServicios(searchValue, { view } = {}) {
  if (!searchValue || searchValue.length < 3) return Promise.resolve([])
  const filtro = and([{ path: 'descripcion', like: searchValue }])
  const params = searchParam(filtro, view ? { view } : {})
  return api.get('/servicios', { params }).then((r) => r.data)
}

// GET /productoalmacen/saldos (stock por almacén). // PENDIENTE: confirmar params en vivo si se usa.
export function getStock(params = {}) {
  return api.get('/productoalmacen/saldos', { params }).then((r) => r.data)
}
